<section class="home">
  <div class="home-container">
    <!-- Left Side -->
    <div class="home-left">
      <img src="assets/on_home.png" alt="ASAPP Illustration" class="home-image" />
      <h1 class="asapp-title">ASAPP</h1>
      <h2 class="asapp-subtitle">SOFTWARE SOLUTIONS</h2>
    </div>

    <!-- Right Side -->
    <div class="home-right">
      <h3 class="welcome-text">WELCOME</h3>
      <div class="company-name">
        <span class="line1">ASAPP SOFTWARE</span>
        <span class="line2">SOLUTIONS</span>
      </div>
      <p class="company-desc">
        Empowering businesses with next-generation web and software solutions.
        Explore our portfolio of modern and scalable digital products.
      </p>
    </div>
  </div>
</section>
